import React, { forwardRef, useEffect, useState } from 'react';
import TextInput from './InputText';
import { formatCurrency } from '../../Utils/Formatters';

/**
 * InputCurrency component for BRL currency format (1.234,56).
 * Based on TextInput.tsx layout and styles.
 */
export default forwardRef(function CurrencyInput(
    { onChange, value = '', ...props }: any,
    ref: any,
) {
    const [displayValue, setDisplayValue] = useState<string>('');

    useEffect(() => {
        setDisplayValue(formatCurrency(value));
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputVal = e.target.value.replace(/\D/g, "");

        if (inputVal === "") {
            if (onChange) {
                onChange({ target: { name: props.name, value: 0 } });
            }
            return;
        }

        // Convert string of digits to decimal (e.g., "123456" -> 1234.56)
        const numericValue = parseInt(inputVal, 10) / 100;

        if (onChange) {
            onChange({
                target: {
                    name: props.name,
                    value: numericValue
                }
            });
        }
    };

    const handleCursorPosition = (e: any) => {
        // Delay to ensure the cursor is moved after browser selection logic
        setTimeout(() => {
            if (e.target) {
                const length = e.target.value.length;
                e.target.setSelectionRange(length, length);
            }
        }, 0);
    };

    return (
        <TextInput
            {...props}
            type="text"
            inputMode="numeric"
            ref={ref}
            value={displayValue}
            onChange={handleChange}
            onFocus={(e: any) => {
                handleCursorPosition(e);
                if (props.onFocus) props.onFocus(e);
            }}
            onClick={(e: any) => {
                handleCursorPosition(e);
                if (props.onClick) props.onClick(e);
            }}
            className={`text-right ${props.className || ''}`}
            placeholder="0,00"
        />
    );
});
